class TestFreak {
  static init() {
    const wrapReviewCount = (observerInstance) => {
      const badgeContainer = document.getElementById('testfreaks-badge');
      if (!badgeContainer) return;

      const countElement = badgeContainer.querySelector('.tf-count');
      if (countElement) {
        const rawText = countElement.innerText;
        const digits = rawText.replace(/\D/g, '');

        if (digits && !rawText.includes('(')) {
          countElement.innerText = `(${digits})`;
        }

        observerInstance.disconnect();
        badgeContainer.classList.add('is-formatted');
      }
    };

    const observer = new MutationObserver(() => {
      wrapReviewCount(observer);
    });

    const targetNode = document.getElementById('testfreaks-badge');

    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
      wrapReviewCount(observer);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => TestFreak.init());